import { useSearchParams } from "react-router-dom";

/**
 * Hook for syncing tab state with URL search params.
 */
export function useTabState(
  paramName: string,
  defaultTab: string,
): [string, (tab: string) => void] {
  const [searchParams, setSearchParams] = useSearchParams();
  const currentTab = searchParams.get(paramName) || defaultTab;

  const setTab = (tab: string) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (tab === defaultTab) {
          next.delete(paramName);
        } else {
          next.set(paramName, tab);
        }
        return next;
      },
      { replace: true },
    );
  };

  return [currentTab, setTab];
}
